module.exports = __webpack_public_path__ + "static/media/detail.74ef7f2d.png";